import { Button, Grid, Select } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Back from "../components/Back";
import EventCard from "../components/EventCard";
import Menu from "../components/Menu";
import { setTitle } from "../helpers/title";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";

export default function Scan() {
  const [eventChoosen, setEventChoosen] = useState("");
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setTitle("Scan Event");
  }, []);

  useEffect(() => {
    baseService.get(
      config.services.global.getEvent,
      (res) => {
        setEvents(res.data);
      },
      (err) => console.log(err)
    );
  }, []);

  function selectEvent(e) {
    const choose = events.find((event) => event._id === e.target.value);
    setEventChoosen(choose);
  }

  return (
    <div>
      <div className="container" />
      <Back title="Scan QR" />
      <div className="content">
        <Grid placeItems="center" gap={5}>
          <Select
            isRequired
            type="text"
            placeholder="Pilih Event"
            name="origin"
            onChange={selectEvent}
          >
            {events.length > 0 &&
              events.map((event) => {
                return (
                  <option key={event._id} value={event._id}>
                    {event.eventName}
                  </option>
                );
              })}
          </Select>
          {eventChoosen && (
            <>
              <div style={{ width: "100%" }}>
                <EventCard data={eventChoosen} />
              </div>
              <Button
                colorScheme="blue"
                width={250}
                onClick={() =>
                  navigate(`/scan/${eventChoosen._id}`, {
                    state: {
                      eventName: eventChoosen.eventName,
                    },
                  })
                }
              >
                Scan QR Code
              </Button>
            </>
          )}
        </Grid>
      </div>
      <Menu />
    </div>
  );
}
